import { render, staticRenderFns } from "./serviceRequests.vue?vue&type=template&id=666bcd33&"
import script from "./serviceRequests.vue?vue&type=script&lang=js&"
export * from "./serviceRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports